import { Button } from "reactstrap";
import { CheckPicker } from "rsuite";
import { FormBuilder } from "../../types/FormBuilderInterfaces";
import { FormAvailableFields } from "./FormBuilderDrawer";

interface Props {
  changeStep: (step: string) => void;
  handleSelectField: (fields: any[]) => void;
  form: FormBuilder;
  availableOptions: FormAvailableFields[];
}

const FormBuilderFieldSelection = ({
  changeStep,
  handleSelectField,
  form,
  availableOptions,
}: Props) => {
  const handleNext = () => {
    changeStep("form-customization");
  };

  return (
    <div className="d-flex align-items-center justify-content-center h-100">
      <div
        style={{
          boxShadow: "0px 1px 8px 2px rgba(0, 0, 0, 0.15)",
          width: 400,
        }}
      >
        <div className="d-flex flex-column p-4 h-100">
          <h3 className="mb-1">Form Fields</h3>
          <p className="text-sm">
            Select the fields you want to build the form with.
          </p>
          <CheckPicker
            data={availableOptions}
            placeholder="Select Fields"
            cleanable
            onChange={(values: string[]) => {
              return handleSelectField(
                values.map((value) => {
                  const option = availableOptions?.find(
                    (option) => option?.value === value
                  );
                  return option?.item;
                })
              );
            }}
            value={form.Fields ? Object.keys(form.Fields) : []}
            className="my-2"
            preventOverflow
          />
          <Button
            color="primary"
            block
            className="align-self-center mt-4"
            onClick={() => handleNext()}
            disabled={!form.Fields || Object.keys(form.Fields).length < 1}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FormBuilderFieldSelection;
